// The MIT License (MIT)
//
// Copyright (c) 2016-2022 Camptocamp SA
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

import {isSafari} from 'ngeo/utils';
import {saveAs} from 'file-saver';

/**
 * A function to start a download for a file.
 *
 * @param {string} content The content of the file to download.
 * @param {string} fileName The name of the file to download.
 * @param {string | undefined} opt_fileType The type of the file to download.
 */
export default function download(content: string, fileName: string, opt_fileType: string | undefined): void {
  // Safari does not properly work with FileSaver. Using the the type 'text/plain'
  // makes it a least possible to show the file content so that users can
  // do a manual download with "Save as".
  // See also: https://github.com/eligrey/FileSaver.js/issues/12
  const fileType: string =
    opt_fileType !== undefined && !isSafari() ? opt_fileType : 'text/plain;charset=utf-8';

  const blob = new Blob(
    [
      new Uint8Array([0xef, 0xbb, 0xbf]), // UTF-8 BOM
      content,
    ],
    {type: fileType}
  );
  saveAs(blob, fileName);
}
